module.exports = __webpack_public_path__ + "img/47-21-flat.55dd4129.jpg";